// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 418) return "js/core/418.js";
	if (chunkId === 506) return "js/core/506.js";
	if (chunkId === 243) return "js/core/243.js";
	if (chunkId === 15) return "js/core/15.js";
	if (chunkId === 853) return "js/core/853.js";
	if (chunkId === 581) return "js/core/581.js";
	if (chunkId === 381) return "js/core/381.js";
	if (chunkId === 36) return "js/core/36.js";
	// return url for filenames based on template
	return undefined;
};